module.exports = __webpack_public_path__ + "img/navigation_hy1.91d74c69.png";